<div class="inner-page-header">
  <h3>تفاصيل الخدمة</h3>
</div>
<div class="new-service-wrapper">
  <form [formGroup]="websiteConfigFormGroup">
    <div class="main-card">
      <div class="form-section">
        <div class="form-group">
          <app-switch-input
            [label]="'حالة الظهور علي الموقع'"
            [labelEn]="'show_on_website'"
            [index]="1"
            [labelDesc]="'(مفعل/غير مفعل)'"
            [value]="websiteConfigFormGroup.controls['show_on_website'].value"
            (valueChanged)="isActiveValueChanged($event)"
          >
          </app-switch-input>
        </div>
        <div class="form-group">
          <app-switch-input
            [label]="'فرض نطاق التغطية'"
            [labelEn]="'is_city_coverage_enforced'"
            [labelDesc]="'(مفعل/غير مفعل)'"
            [value]="
              websiteConfigFormGroup.controls['is_city_coverage_enforced'].value
            "
            (valueChanged)="isActiveValueChanged($event)"
          >
          </app-switch-input>
        </div>
        <div class="form-group">
          <app-switch-input
            [label]="'الظهور في قسم الخدمات الحكومية'"
            [labelEn]="'show_in_government_section'"
            [labelDesc]="'(مفعل/غير مفعل)'"
            [value]="
              websiteConfigFormGroup.controls['show_in_government_section'].value
            "
            (valueChanged)="isActiveValueChanged($event)"
          >
          </app-switch-input>
        </div>
      </div>

      <div class="configration-title">
        <h5>{{ serviceName }}</h5>
      </div>

      <div class="form-section">
        <div class="form-group notes-section">
          <label for="" class="form-label"
            >وصف مختصر <span class="red">*</span></label
          >
          <div
            formControlName="short_description"
            class="custom-height"
            [ngxSummernote]="summerNoteConfig"
            [class.ng-invalid]="
              submitted &&
              websiteConfigFormGroup.controls['short_description'].invalid
            "
            [class.ng-touched]="
              websiteConfigFormGroup.controls['short_description'].touched
            "
            [class.submitted]="submitted"
          ></div>
        </div>

        <div class="form-group notes-section">
          <label for="" class="form-label"
            >وصف تفصيلي <span class="red">*</span></label
          >
          <div
            formControlName="long_description"
            class="custom-height"
            [ngxSummernote]="summerNoteConfig"
            [class.ng-invalid]="
              submitted &&
              websiteConfigFormGroup.controls['long_description'].invalid
            "
            [class.ng-touched]="
              websiteConfigFormGroup.controls['long_description'].touched
            "
            [class.submitted]="submitted"
          ></div>
        </div>

        <div class="form-group">
          <label for="" class="form-label">
            تاجات الخدمة <span class="red">*</span></label
          >
          <app-select
            [optionItems]="tags"
            [placeholder]="'يرجى تحديد أهداف الخدمة'"
            [id]="'tags'"
            [initValues]="serviceTags"
            [maxLength]="1"
            (selectedOptions)="setFormControlValue('tags', $event)"
            [class.ng-invalid]="
              submitted && websiteConfigFormGroup.controls['tags'].invalid
            "
            [class.ng-touched]="websiteConfigFormGroup.controls['tags'].touched"
            [class.submitted]="submitted"
          >
          </app-select>
        </div>

        <div class="form-group">
          <label for="" class="form-label"
            >تصنيف الخدمة <span class="red">*</span></label
          >
          <ng-select
            bindLabel="name"
            class="single-select"
            placeholder=""
            appendTo="body"
            formControlName="classification"
            [searchable]="true"
            [clearable]="true"
          >
            @for (classification of classifications; track classification.id) {
              <ng-option [value]="classification.id">
                {{ classification.name }}
              </ng-option>
            }
          </ng-select>
        </div>

        @if (
          websiteConfigFormGroup.controls["is_city_coverage_enforced"].value
        ) {
          <div class="form-group">
            <label for="" class="form-label">
              منطقة تقديم الخدمة <span class="red">*</span></label
            >
            <app-select
              [optionItems]="regions"
              [placeholder]="'منطقة تقديم الخدمة'"
              [id]="'region_IDs'"
              [initValues]="savedRegionIDs"
              [maxLength]="2"
              [bindValue]="'pk'"
              (selectedOptions)="onRegionSelected($event)"
              [class.ng-invalid]="
                submitted && websiteConfigFormGroup.get('regions')?.invalid
              "
              [class.ng-touched]="
                websiteConfigFormGroup.controls['regions'].touched
              "
              [class.submitted]="submitted"
            >
            </app-select>
          </div>

          <div class="form-group">
            <label for="" class="form-label">
              مدن تقديم الخدمة <span class="red">*</span></label
            >
            <app-select
              [optionItems]="cities"
              [placeholder]="'مدن تقديم الخدمة'"
              [id]="'city_IDs'"
              [initValues]="savedCityIDs"
              [maxLength]="2"
              [bindValue]="'pk'"
              (selectedOptions)="onCitiesSelected($event)"
              [readonly]="!savedRegionIDs || savedRegionIDs.length === 0"
              [class.ng-invalid]="
                submitted && websiteConfigFormGroup.get('cities')?.invalid
              "
              [class.ng-touched]="
                websiteConfigFormGroup.controls['cities'].touched
              "
              [class.submitted]="submitted"
            >
            </app-select>
          </div>
        }
        <div class="form-group">
          <label for="" class="form-label"
            >الشروط والأحكام<span class="red">*</span></label
          >
          <ng-select
            bindLabel="name"
            class="single-select"
            placeholder=""
            appendTo="body"
            formControlName="terms_and_conditions_template"
            [searchable]="true"
            [clearable]="true"
          >
            @for (termsCondition of termsConditions; track termsCondition.id) {
              <ng-option [value]="termsCondition.id">
                {{ termsCondition.name }}
              </ng-option>
            }
          </ng-select>
        </div>
      </div>

      <div class="form-section payment-methods mb-3">
        <div class="method">
          <div class="form-group">
            <label for="" class="form-label">
              طريقة الدفع <span class="red">*</span></label
            >
            <app-select
              [optionItems]="paymentMethods"
              [placeholder]="'يرجى تحديد طريقة الدفع'"
              [id]="'payment_methods_IDs'"
              [initValues]="servicePaymentMethods"
              [maxLength]="2"
              (selectedOptions)="
                setFormControlValue('payment_methods_IDs', $event)
              "
              [class.ng-invalid]="
                submitted &&
                websiteConfigFormGroup.controls['payment_methods_IDs'].invalid
              "
              [class.ng-touched]="
                websiteConfigFormGroup.controls['payment_methods_IDs'].touched
              "
              [class.submitted]="submitted"
            >
            </app-select>
          </div>
        </div>

        <div formArrayName="payment_methods" class="methods-wrapper mb-3">
          @for (
            method of paymentMethodsFormArray.controls;
            let i = $index;
            track method
          ) {
            <div class="method">
              <h6 class="py-3 mb-0">{{ method.value.name }}</h6>
              <div [formGroupName]="i">
                <div class="row">
                  <div class="form-group col-6">
                    <label for="" class="form-label"
                      >نسبة الخصم <span class="red">*</span></label
                    >
                    <input
                      type="number"
                      class="form-control"
                      formControlName="discount"
                    />
                    <span class="static-code">%</span>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-6">
                    <label for="" class="form-label"
                      >رسالة للعميل (الموقع) <span class="red">*</span></label
                    >
                    <div
                      formControlName="description"
                      class="custom-height"
                      [ngxSummernote]="summerNoteConfig"
                      [class.ng-invalid]="
                        submitted && method.get('description').invalid
                      "
                      [class.ng-touched]="method.get('description').touched"
                      [class.submitted]="submitted"
                    ></div>
                  </div>

                  <div class="form-group col-6">
                    <label for="" class="form-label"
                      >رسالة للخبير <span class="red">*</span></label
                    >
                    <div
                      formControlName="expert_description"
                      class="custom-height"
                      [ngxSummernote]="summerNoteConfig"
                      [class.ng-invalid]="
                        submitted && method.get('expert_description').invalid
                      "
                      [class.ng-touched]="
                        method.get('expert_description').touched
                      "
                      [class.submitted]="submitted"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="form-section">
        <div class="form-group">
          <label for="" class="form-label"
            >سعر الخدمة (يبدأ من) <span class="red">*</span></label
          >
          <input type="number" class="form-control" formControlName="price" />
          <span class="static-code">ر.س</span>
        </div>

        <div class="form-group">
          <label for="" class="form-label"
            >وصف تسعير الخدمة<span class="red">*</span></label
          >
          <div
            formControlName="pricing_hint"
            class="custom-height"
            [ngxSummernote]="summerNoteConfig"
            [class.ng-invalid]="
              submitted &&
              websiteConfigFormGroup.controls['pricing_hint'].invalid
            "
            [class.ng-touched]="
              websiteConfigFormGroup.controls['pricing_hint'].touched
            "
            [class.submitted]="submitted"
          ></div>
        </div>

        <div class="form-group">
          <label for="" class="form-label"
            >مدة التسليم<span class="red">*</span></label
          >
          <input
            type="text"
            class="form-control"
            formControlName="time_description"
          />
        </div>

        <div class="form-group">
          <label for="" class="form-label"
            >وصف مدة تنفيذ الخدمة<span class="red">*</span></label
          >
          <div
            formControlName="service_time_hint"
            class="custom-height"
            [ngxSummernote]="summerNoteConfig"
            [class.ng-invalid]="
              submitted &&
              websiteConfigFormGroup.controls['service_time_hint'].invalid
            "
            [class.ng-touched]="
              websiteConfigFormGroup.controls['service_time_hint'].touched
            "
            [class.submitted]="submitted"
          ></div>
        </div>

        <div class="form-group">
          <file-input
            [file]="reportImage"
            [fileIndex]="1"
            [fileName]="'name'"
            [fileLabel]="'fileLabel'"
            (delete)="deleteImage($event)"
            (save)="handleImage($event)"
          ></file-input>
        </div>

        <div class="form-group">
          <label for="" class="form-label">رابط نموذج التقرير</label>
          <input
            type="text"
            class="form-control"
            formControlName="report_sample_link"
          />
        </div>
      </div>

      <configuration-group
        title="مناسب لي"
        key="secondary_tags"
        [items]="{
          secondary_tags:
            websiteConfigFormGroup.controls['secondary_tags'].value,
        }"
        (values)="setValues($event)"
      >
      </configuration-group>

      <configuration-group
        title="الخدمة تشمل"
        key="service_includes"
        [items]="{
          service_includes:
            websiteConfigFormGroup.controls['service_includes'].value,
        }"
        (values)="setValues($event)"
      >
      </configuration-group>

      <configuration-group
        title="الخدمة لا تشمل"
        key="service_excludes"
        [items]="{
          service_excludes:
            websiteConfigFormGroup.controls['service_excludes'].value,
        }"
        (values)="setValues($event)"
      >
      </configuration-group>

      <service-faqs
        [items]="websiteConfigFormGroup.controls['faqs'].value"
        (values)="setFaqsValues($event)"
      >
      </service-faqs>

      <!-- Gallery Section - Admin & Marketing -->
      @if (canAccessGallery()) {
        <app-service-gallery
          [serviceId]="serviceId"
          (imagesChanged)="onGalleryImagesChanged($event)"
          (error)="showGalleryError($event)"
        ></app-service-gallery>
      }

      @if (errorMsg) {
        <div class="alert-box mt-3">
          <img
            src="assets/images/svg/error-icon.svg"
            class="close-alert"
            (click)="closeError()"
            alt=""
          />
          <p class="alert-msg">{{ message }}</p>
        </div>
      }
    </div>

    <div class="double-action">
      <app-action-button (submitAction)="save($event)"></app-action-button>
    </div>
  </form>
</div>

